import { render, staticRenderFns } from "./homeAbout.vue?vue&type=template&id=4453e4ec&scoped=true"
import script from "./homeAbout.vue?vue&type=script&lang=js"
export * from "./homeAbout.vue?vue&type=script&lang=js"
import style0 from "./homeAbout.vue?vue&type=style&index=0&id=4453e4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4453e4ec",
  null
  
)

export default component.exports